import React from 'react'

import { Container, Title, Important, Text } from './PatTooltip.style'

const PatTooltip = ({ color }) => (
    <Container s$color={color} data-testid="patTooltip">
        <Title>O que é PAT?</Title>
        <Text>
            <br />
            <br />O PAT (Programa de Alimentação do Trabalhador) é
            <br />
            um programa governamental de adesão voluntária
            <br />
            que busca estimular o empregador a fornecer
            <br />
            alimentação nutricionalmente adequada aos seus
            <br />
            trabalhadores por meio da concessão de incentivos
            <br />
            fiscais.
            <br />
            <br />
            <Important>Importante:</Important> clientes inscritos no programa
            não
            <br />
            poderão permitir a transferência de crédito entre
            <br />
            os saldos de Alimentação e Refeição.
        </Text>
    </Container>
)

export default PatTooltip
